const editStage = ({ id, ...data }) => ({
  method: "PUT",
  url: `/stages/${id}`,
  data,
});

export const stageApi = {
  editStage,
};
